import { loginRequest, graphConfig } from "../config/msalConfig";
import { msalInstance } from "./msalInstance";

/**
 * Office 365 Authentication Service
 * Handles Microsoft authentication for teachers and students
 */
class Office365AuthService {
  /**
   * Sign in with popup
   */
  async loginWithPopup() {
    try {
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      console.log("Login successful:", loginResponse);
      return {
        success: true,
        account: loginResponse.account,
        accessToken: loginResponse.accessToken
      };
    } catch (error) {
      console.error("Login with popup error:", error);
      return {
        success: false,
        error: error.message || "Login failed"
      };
    }
  }

  /**
   * Sign in with redirect
   */
  async loginWithRedirect() {
    try {
      await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("Login with redirect error:", error);
      throw error;
    }
  }

  /**
   * Get access token silently
   */
  async getAccessToken() {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No accounts found");
    }

    const request = {
      ...loginRequest,
      account: accounts[0]
    };

    try {
      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      console.error("Silent token acquisition failed:", error);
      // Fallback to interactive method
      const response = await msalInstance.acquireTokenPopup(request);
      return response.accessToken;
    }
  }

  /**
   * Get user profile from Microsoft Graph
   */
  async getUserProfile() {
    try {
      const accessToken = await this.getAccessToken();
      const response = await fetch(graphConfig.graphMeEndpoint, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      if (!response.ok) {
        throw new Error("Failed to fetch user profile");
      }

      const profile = await response.json();
      return {
        success: true,
        profile
      };
    } catch (error) {
      console.error("Get user profile error:", error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Get current account
   */
  getCurrentAccount() {
    const accounts = msalInstance.getAllAccounts();
    return accounts.length > 0 ? accounts[0] : null;
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated() {
    return msalInstance.getAllAccounts().length > 0;
  }

  /**
   * Logout
   */
  async logout() {
    try {
      await msalInstance.logoutPopup({
        mainWindowRedirectUri: "/"
      });
      return { success: true };
    } catch (error) {
      console.error("Logout error:", error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  /**
   * Logout with redirect
   */
  async logoutRedirect() {
    try {
      await msalInstance.logoutRedirect({
        postLogoutRedirectUri: "/"
      });
    } catch (error) {
      console.error("Logout redirect error:", error);
      throw error;
    }
  }
}

const office365AuthService = new Office365AuthService();
export default office365AuthService;
